import axios, { AxiosResponse } from "axios";
import { ensureSession, getAccessToken, handleUnauthorized } from "../auth";
import { getUserFacingError } from "./userFacingError";

async function getApi(url: string, payload?: any): Promise<any> {
  try {
    const ok = await ensureSession();
    if (!ok) {
      handleUnauthorized();
      return {
        message: "Session expired — please log in",
        error: "Session expired — please log in",
        status_code: 401,
        __userFacingError: true,
      };
    }
    const response: AxiosResponse = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${getAccessToken()}`
      }
    });
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        handleUnauthorized();
      }
    }
    const message = getUserFacingError(error);
    return {
      message,
      error: message,
      status_code: axios.isAxiosError(error) ? error.response?.status || 0 : 0,
      __userFacingError: true,
    };
  }
}

export default getApi;
